/* eslint-disable no-debugger */
import { Injectable } from '@angular/core';
// import { ProtocolDetailsResponse } from '../interfaces/protocol-details';
import { environment } from '@/environments/environment';
import axios from 'axios';
import { ToastService } from './script/toast.service';
import { HomeResponse } from '@/app/interfaces/home';
import { LoaderService } from '@/app/services/interceptor/loader-service';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private readonly apiUrl = '/api/aurora/listado';

  constructor(
    private toastService: ToastService,
    private loader: LoaderService
  ) {}

  async getHome(hasDpdRole: boolean = false): Promise<HomeResponse> {
    try {
      this.loader.show();
      const user = JSON.parse(localStorage.getItem('userData'));
      const params = {
        codigo_puesto: user.roleCode,
        codigo_organismo: user.orgCode,
        dpd: hasDpdRole,
      };

      const response = await axios.post<HomeResponse>(
        `${environment.url}${this.apiUrl}`,
        { filters: { params }, list: 'home' },
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      this.toastService.showError(
        'Error al obtener los datos del home',
        error?.response?.data?.message || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      this.loader.hide();
    }
  }
}
